import Api from '@/api';

/**
 * Generate full name from `currentUser` state based on current state.
 * @param {*} state - Vuex User module state
 * @returns {string} If given and family names do not exist will return an empty string, if only
 * given name exists will return given name, otherwise will return given and family name
 */
const currentUserFullName = state => {
  if (!state.currentUser) {
    return '';
  }

  if (!state.currentUser.familyName) {
    return state.currentUser.givenName;
  }

  return `${state.currentUser.givenName} ${state.currentUser.familyName}`;
};

const userAuthToken = () => Api.authService.getAuthToken();

export default {
  currentUserFullName,
  userAuthToken,
};
